import gql from "graphql-tag";

export default gql`
  query getOrderSiteSetting {
    getOrderSiteSetting {
      orderCounter
      orderPreTag
      tokenCounter
    }
  }
`;
